<template>
  <v-container class="desktop-view-container" fluid>
    <v-row no-gutters class="fill-height">
      <!-- Sidebar -->
      <v-col cols="auto" class="hidden-xs-only">
        <nav-bar />
      </v-col>

      <!-- Main content -->
      <v-col>
        <v-row class="flex-column fill-height no-gutters">
          <!-- Mobile nav -->
          <v-col cols="12" class="hidden-sm-and-up">
            <nav-bar />
          </v-col>

          <!-- Page content -->
          <v-col cols="12" class="pa-3 overflow-y-auto">
            <router-view />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import NavBar from "./components/NavBar"

export default {
  name: "settings",
  components: {
    NavBar,
  },
}
</script>

<style scoped>
.desktop-view-container {
  height: calc(100vh - 58px);
}
</style>